import * as React from "react";
import ReactPlayer from "react-player/youtube";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { AccessTime } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import PlayCircleImage from "assets/icons/play_circle.svg";
import pageStyles from "./styles";
import * as moment from "moment";
import { DivScrollHorizontal } from "components";
import { Store } from "hooks/main_store";

// interface SuggestedItemVideo {
//   name: string;
//   description: string;
//   url: string;
// }

interface SuggestedVideosProps {
  title: string;
  data: any[];
  beforeToExit?: (callback: () => void) => () => void;
}

const SuggestedVideos = ({
  title,
  data,
  beforeToExit,
}: SuggestedVideosProps) => {
  const styles = pageStyles();
  const navigate = useNavigate();
  const { state } = useContext(Store);

  const [scrolled, setScrolled] = useState(false);

  const handleRedirect = (callback: () => void) => () => {
    if (beforeToExit) {
      beforeToExit(callback)();
    } else {
      callback();
    }
  };

  const showWaiting = useCallback(
    (id: string) => {
      const lastDatePlayed = state.rankingHistory?.[id];
      const countSeconds = moment().diff(
        moment(lastDatePlayed, "x"),
        "seconds",
      );

      return lastDatePlayed && countSeconds < 86400;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [state.rankingHistory],
  );

  const returnOrderedContent = useMemo(() => {
    return data
      .map((content) => ({ ...content, isWaiting: showWaiting(content.id) }))
      .sort((a, b) => (a?.isWaiting ? 1 : 0) - (b?.isWaiting ? 1 : 0));
  }, [data, showWaiting]);

  const renderVideos = () =>
    returnOrderedContent
      .slice(0, 6)
      .map(
        (
          { name, description, url, id, imageUrl, created, isWaiting },
          index,
        ) => (
          <div
            className={styles.containerRecommenedVideo}
            key={`${name}-${index}`}
          >
            <div
              className={styles.playerRecommenedVideo}
              onClick={handleRedirect(() => navigate(`/detail-video?id=${id}`))}
            >
              {imageUrl ? (
                <img src={imageUrl} className={styles.imageVideo} alt="Video" />
              ) : (
                <ReactPlayer
                  url={url}
                  light
                  width="100%"
                  height="100%"
                  playing={false}
                  playIcon={<></>}
                />
              )}
              <div className={styles.overlayPlayer}>
                <img
                  alt="Play"
                  className={styles.iconPlayer}
                  src={PlayCircleImage}
                />
              </div>
            </div>
            <p className={styles.nameAuthorRecommended}>{name}</p>
            <p className={styles.descriptionRecommended}>{description}</p>
            {moment().diff(moment(created, "x"), "d") < 7 ? (
              <div className={styles.newBadge}>Recien agregado</div>
            ) : (
              <></>
            )}
            {isWaiting && (
              <Tooltip title="Aún debes esperar para reproducirlo">
                <div className={styles.iconWaiting}>
                  <AccessTime />
                </div>
              </Tooltip>
            )}
          </div>
        ),
      );

  const handleScroll = () => {
    setScrolled(true);
  };

  useEffect(() => {
    const callback = setTimeout(handleScroll, 9000);

    return () => clearTimeout(callback);
  }, []);

  if (data?.length > 0) {
    return (
      <DivScrollHorizontal label={title} onScroll={handleScroll}>
        {scrolled ? (
          renderVideos()
        ) : (
          <div className={[styles.rowRecommended, styles.autoScroll].join(" ")}>
            {renderVideos()}
          </div>
        )}
      </DivScrollHorizontal>
    );
  }

  return <></>;
};

export default SuggestedVideos;
